"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.submitFeedback = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _api = require("../utils/api");

var submitFeedback = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(environment, orgId, message, source) {
    var result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat((0, _api.getSwicusWebAppUrl)(environment), "/v1/submit-feedback"), {
              headers: {
                'content-type': 'application/json',
                'x-request-id': (0, _api.generateRequestID)()
              },
              method: 'POST',
              credentials: 'include',
              body: (0, _stringify["default"])({
                message: message,
                orgId: orgId,
                source: source
              })
            });

          case 2:
            result = _context.sent;
            (0, _api.assertResponseSuccess)(result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function submitFeedback(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.submitFeedback = submitFeedback;